import { IntegrationImage } from "./integration-image.model";
import { IntegrationParam } from "./integration-param.model";


export class Integration {
    public id: number;
    public name?: string;
    public active?: boolean;
    public cardUuid?: string;
    public activationTime?: string;
    public description?: string;
    public params: IntegrationParam[] = [] as IntegrationParam[];
    public images: IntegrationImage[] = [] as IntegrationImage[];

    constructor(
        id: number, 
        //name: string, 
        //cardUuid: string, 
        //pin: string,
        //active: boolean,
        //description: string,
        ) {
        this.id = id;
        //this.name = name;
        //this.cardUuid = cardUuid;
        //this.pin = pin;
        //this.active = active;
        //this.description = description;
    }
}